import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { SwiftIdEnumCollection } from './swift-id-enum.types';

export function swiftIdEnumBackend(): Backend<SwiftIdEnumCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: `swift-id/enum.php`,
      method: 'GET',
      isGaf: true,
      params: {
        type: query?.searchQueryParams.type,
        occupationType: query?.searchQueryParams.occupationType,
        industry: query?.searchQueryParams.industry,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
